var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PPNController = /** @class */ (function () {
    function PPNController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/ppn/signin" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    PPNController.SignIn = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/ppn/signin", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/ppe_saml" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    PPNController.SignInToPpe = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/ppe_saml", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/ppn" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    PPNController.SignInPpn = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/ppn", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return PPNController;
}());
export { PPNController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PPNController.js.map